import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import Booking from "@/pages/Booking";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

const withSeo = (title, description, el) => (
  <>
    <Seo title={title} description={description} />
    {el}
  </>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <div className="grain-overlay" />
      <HelmetProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route
              path="/"
              element={withSeo(
                "Lawn Care, Gardens & Landscaping in Ontario | Skloccom",
                "Skloccom crafts precision lawn care, bespoke gardens, stonework and four-season property care across Southern Ontario. Book a free on-site quote today.",
                <Home />
              )}
            />
            <Route
              path="/services"
              element={withSeo(
                "Services & Rates | Skloccom Lawn & Garden Care",
                "Nine services from precision grass cutting and sodding to interlock patios and snow removal — clear rates, one crew, all four seasons.",
                <Services />
              )}
            />
            <Route
              path="/about"
              element={withSeo(
                "About the Crew | Skloccom Lawn & Garden Care",
                "Owner-operated since 2022. Meet the Skloccom crew behind Southern Ontario's sharpest lawns, gardens and stonework.",
                <About />
              )}
            />
            <Route
              path="/gallery"
              element={withSeo(
                "Selected Works | Skloccom Lawn & Garden Care",
                "Selected lawn, garden and hardscaping projects by Skloccom across Burlington, Oakville, Hamilton and beyond.",
                <Gallery />
              )}
            />
            <Route
              path="/contact"
              element={withSeo(
                "Get a Free Quote | Skloccom Lawn & Garden Care",
                "Tell us about your yard. Every Skloccom enquiry lands directly with Chris and most quotes come back within one business day.",
                <Contact />
              )}
            />
            <Route
              path="/booking"
              element={withSeo(
                "Book a Free On-Site Quote | Skloccom",
                "Pick a date and time for your free on-site Skloccom quote. Visits run Monday to Saturday across Southern Ontario.",
                <Booking />
              )}
            />
          </Routes>
          <Footer />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
